import { type FunctionComponent } from 'react';

export type CharacterCountProps = {
	testId?: string;
	invalid?: boolean;
	maxLength?: number;
	currentCount?: number;
};

export const CharacterCount: FunctionComponent<CharacterCountProps> = ({ testId, invalid, currentCount, maxLength }) => (
	<div data-testid={testId + '_counter'} className={`${invalid ? 'theme-error' : 'theme-grey'} f7 mt1 content-end tr flex-grow-1`}>
		{currentCount ?? '0'}
		{(maxLength || 0) > 0 && `/${maxLength}`}
	</div>
);
